var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-2",
    d: "M4 0.5H16C17.3789 0.5 18.5 1.62114 18.5 3V23C18.5 23.2739 18.2739 23.5 18 23.5H2C1.72614 23.5 1.5 23.2739 1.5 23V3C1.5 1.62114 2.62114 0.5 4 0.5Z",
    fill: "#EAEEF2",
    stroke: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M11.75 11.125H5.25C4.835 11.125 4.5 10.79 4.5 10.375C4.5 9.96 4.835 9.625 5.25 9.625H11.75C12.165 9.625 12.5 9.96 12.5 10.375C12.5 10.79 12.165 11.125 11.75 11.125Z",
    fill: "#AFB8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M14.75 14.375H5.25C4.835 14.375 4.5 14.04 4.5 13.625C4.5 13.21 4.835 12.875 5.25 12.875H14.75C15.165 12.875 15.5 13.21 15.5 13.625C15.5 14.04 15.165 14.375 14.75 14.375Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarMiddle);
export default __webpack_public_path__ + "static/media/bar-middle.c857d0dc1aa2bee913b62813f1467c42.svg";
export { ForwardRef as ReactComponent };